import useWindowSize from '@/lib/hooks/useWindowSize';

export const PRODUCT_TOUR_MIN_WIDTH = 800;

export default function useProductTourDecision() {
  const { width } = useWindowSize();

  return !!width && width >= PRODUCT_TOUR_MIN_WIDTH;
}
